import { frontendURL } from '../../../../helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const SsoWizard = () => import('./SsoWizard.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sso-wizard'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'SSO_WIZARD.TITLE',
        icon: 'lock-shield',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'sso_wizard_index',
          component: SsoWizard,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
